<!--
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-21 14:51:02
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-30 11:11:32
 * @FilePath: /wemeet-admin-new/src/views/recruitment/talent/TalentDetail.vue
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
-->
<template>
  <el-dialog destroy-on-close :model-value="visible" title="查看详情" width="75vw" @close="close" @open="open">
    <div class="talent-detail wemeet-description">
      <h3>人才基本信息</h3>
      <div v-if="talentInfo">
        <el-row>
          <el-col class="is-label" :span="3">用户名</el-col>
          <el-col :span="5">{{ talentInfo.name }}</el-col>
          <el-col class="is-label" :span="3">手机号码</el-col>
          <el-col :span="5">{{ talentInfo.phone }}</el-col>
          <el-col class="is-label" :span="3">电子邮箱</el-col>
          <el-col :span="5">{{ talentInfo.email }}</el-col>
        </el-row>
        <el-row>
          <el-col class="is-label" :span="3">机构</el-col>
          <el-col :span="5">{{ talentInfo.company }}</el-col>
          <el-col class="is-label" :span="3">职位</el-col>
          <el-col :span="5">{{ talentInfo.position }}</el-col>
          <el-col class="is-label" :span="3">头像</el-col>
          <el-col :span="5">
            <el-image :src="talentInfo.avatar" style="width: 80px; height: 80px" />
          </el-col>
        </el-row>
        <el-row>
          <el-col class="is-label" :span="3">地区</el-col>
          <el-col :span="21">{{ talentInfo.address || talentInfo.country }}</el-col>
        </el-row>
      </div>

      <h3>人才实名信息</h3>
      <div v-if="talentInfo">
        <el-row>
          <el-col class="is-label" :span="3">真实姓名</el-col>
          <el-col :span="5">{{ talentInfo.realName }}</el-col>
          <el-col class="is-label" :span="3">实名状态</el-col>
          <el-col :span="5">{{ talentInfo.isReal ? '已' : '未' }}实名</el-col>
          <el-col class="is-label" :span="3">实名类型</el-col>
          <el-col :span="5">{{ talentInfo.realType }}</el-col>
        </el-row>
        <el-row>
          <el-col class="is-label" :span="3">证件号码</el-col>
          <el-col :span="21">{{ talentInfo.idCardNo }}</el-col>
        </el-row>
      </div>

      <h3>人才入库时间</h3>
      <div v-if="talentInfo">
        <el-row>
          <el-col class="is-label" :span="3">入库时间</el-col>
          <el-col :span="21">{{ talentInfo.createTime }}</el-col>
        </el-row>
      </div>

      <h3>人才状态</h3>
      <div v-if="talentInfo">
        <el-row>
          <el-col class="is-label" :span="3">人才状态</el-col>
          <el-col :span="21">{{ TALENT_STATUS_CN[talentInfo.status] }}</el-col>
        </el-row>
      </div>

      <h3>简历投递记录</h3>
      <!-- 表格 -->
      <el-table v-loading="loading" border :data="tableData" :max-height="300" table-layout="auto">
        <el-table-column label="岗位名称" prop="jobName" />
        <el-table-column label="岗位类型" prop="jobType" />
        <el-table-column label="薪资范围">
          <template #default="{ row }">{{ salaryLabel(row) }}</template>
        </el-table-column>
        <el-table-column label="投递时间" prop="createTime" />
        <el-table-column label="推荐人">
          <template #default="{ row }">
            <el-link
              v-if="row.recommendCode && row.recommendName"
              type="primary"
              :underline="false"
              @click="showDetail(row)"
            >
              {{ row.recommendName }}
            </el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="人才状态" prop="status">
          <template #default="{ row }">
            {{ TALENT_STATUS_CN[row.status] }}
          </template>
        </el-table-column>
        <el-table-column label="入职时长" prop="tag">
          <template #default="{ row }">
            {{ isNumber(row.entryDays) ? row.entryDays + '天' : '-' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template #default="{ row }">
            <el-link type="primary" :underline="false" @click="changeStatus(row)">更改状态</el-link>
            <el-link type="primary" :underline="false" @click="showForm(row)">查看表单</el-link>
          </template>
        </el-table-column>
        <template #empty>
          <el-empty class="vab-data-empty" description="暂无数据" />
        </template>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-model:current-page="currentPage"
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="total"
        @current-change="onCurrentChange"
      />
    </div>
    <template #footer>
      <el-button @click="close">关闭</el-button>
    </template>
  </el-dialog>

  <!-- 更改状态 -->
  <el-dialog v-model="statusModal.visible" destroy-on-close title="更改状态" :width="520" @close="closeStatusModal">
    <el-radio-group v-if="statusModal.data" v-model="statusModal.data.status">
      <el-radio v-for="item in recommenderStatusOptions" :key="item.value" :label="item.value">
        {{ item.label }}
      </el-radio>
    </el-radio-group>
    <template #footer>
      <el-button @click="closeStatusModal">取消</el-button>
      <el-button type="primary" @click="confirmStatus">确定</el-button>
    </template>
  </el-dialog>

  <!-- 查看表单 -->
  <TalentForm :id="formModal.data?.id" :visible="formModal.visible" @close="closeForm" />

  <!-- 推荐人详情 -->
  <RecommenderDetail
    :recommend-code="detailModal.recommendCode"
    :visible="detailModal.visible"
    @close="handleDetailClose"
  />
</template>

<script setup>
  import { defineProps, defineEmits, ref, reactive, getCurrentInstance } from 'vue'
  import { getTalentDetail, updateTalentStatus } from '@/api/recruitment'
  import { TALENT_STATUS, TALENT_STATUS_CN } from '../context'
  import TalentForm from './TalentForm.vue'
  import { salaryLabel } from '../helper'
  import { useLocalPagination } from '@/hooks/usePagination'
  import { pick, isNumber } from 'lodash'
  import RecommenderDetail from '../recommend/RecommenderDetail.vue'

  const props = defineProps({
    visible: Boolean,
    id: Number,
  })

  const emit = defineEmits(['close'])

  const { proxy } = getCurrentInstance()

  const recommenderStatusOptions = Object.values(TALENT_STATUS).map((v) => ({
    value: v,
    label: TALENT_STATUS_CN[v],
  }))

  const loading = ref(false)
  const tableDataSource = ref([])
  const talentInfo = ref()

  const { data: tableData, currentPage, pageSize, total, onCurrentChange } = useLocalPagination(tableDataSource)

  function getDetail() {
    getTalentDetail(props.id)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { userDeliverResumesHistoryVo, ...info } = data
        talentInfo.value = info
        tableDataSource.value = userDeliverResumesHistoryVo.map((e) => {
          e.tag = e.tag?.split(',') || []
          return e
        })
      })
      .finally(() => {
        loading.value = false
      })
  }

  function open() {
    getDetail()
  }

  function close() {
    emit('close')
  }

  const statusModal = reactive({
    visible: false,
    data: null,
  })

  function changeStatus(row) {
    statusModal.data = { ...row }
    statusModal.visible = true
  }

  function closeStatusModal() {
    statusModal.visible = false
    statusModal.data = null
  }

  function confirmStatus() {
    const params = pick(statusModal.data, 'id', 'status')
    updateTalentStatus(params).then(({ code }) => {
      if (code !== 200) return
      closeStatusModal()
      proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
      getDetail()
    })
  }

  const formModal = reactive({
    visible: false,
    data: null,
  })

  function showForm(row) {
    formModal.data = row
    formModal.visible = true
  }

  function closeForm() {
    formModal.visible = false
    formModal.data = null
  }

  const detailModal = reactive({
    visible: false,
    data: null,
  })

  function showDetail(row) {
    detailModal.recommendCode = row.recommendCode
    detailModal.visible = true
  }

  function handleDetailClose() {
    detailModal.visible = false
    detailModal.recommendCode = ''
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/css/description.scss';
</style>
